import React, { useEffect, useState } from 'react'
import ImgPhone1 from '@/assets/images/phone-1.png'
import ImgPhone2 from '@/assets/images/phone-2.png'
import ImgPhone3 from '@/assets/images/phone-3.png'
import ImgPhone4 from '@/assets/images/phone-4.png'
import ImgPhone5 from '@/assets/images/phone-5.png'

/* consola images */
import ps4Pro1 from '@/assets/images/ps4-pro-1.png'
import ps4Pro2 from '@/assets/images/ps4-pro-2.png'
import ps4Pro3 from '@/assets/images/ps4-pro-3.png'
import ps4Pro4 from '@/assets/images/ps4-pro-4.png'
import ps4Pro5 from '@/assets/images/ps4-pro-5.png'
import ps4Pro6 from '@/assets/images/ps4-pro-6.png'
import ps4Pro7 from '@/assets/images/ps4-pro-7.png'

import nintendo from '@/assets/images/nintendo-1.png'
import nintendo2 from '@/assets/images/nintendo-2.png'
import nintendo3 from '@/assets/images/nintendo-3.png'
import nintendo4 from '@/assets/images/nintendo-4.png'
import nintendo5 from '@/assets/images/nintendo-5.png'
import nintendo6 from '@/assets/images/nintendo-6.png'

import { Button } from '@/components/ui/button'
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@nextui-org/react'
import { MdClose, MdImageSearch, MdOutlineWarningAmber } from 'react-icons/md'
import GradientText from '@/components/GradientText/GradientText'
import NUIAlert from '@/components/Alert/Alert'
import { useParams } from 'react-router-dom'
import { enqueueSnackbar } from 'notistack'
import { webApiService } from '@/services'
import StepCard from './StepCard'
import { useStepFooterAction } from '../context/StepFooterActionContext'
import { useTradeinContext } from '../hooks/useTradeinContext'
import { currencyFormat } from '@/utils/currencyFormat'
import { imagesToBase64Array } from '@/utils/imagesToBase64Array'
import imageCompression from 'browser-image-compression'
import { IConfigSeller } from '@/models/configSeller'
import { useSelector } from 'react-redux'
import { useJoyRideContext } from '../context/JoyRideContext'
import { canReanalyzeIA } from '@/utils/batteryStep'
import { hasInvalidImei, hasPendingRecalculate } from '@/utils/canShowIAEvaluation'
import { canEvaluateBatteryWithSwitch } from '@/utils/canEvaluateBatteryWithSwitch'
import { isConsole } from '@/utils/isConsole'

const defaultImagesSmartPhone = [ImgPhone1, ImgPhone2, ImgPhone3, ImgPhone4, ImgPhone5, ImgPhone3]
const defaultConsoles = [ps4Pro1, ps4Pro2, ps4Pro3, ps4Pro4, ps4Pro5, ps4Pro6, ps4Pro7]
const defaultImagesNintendo = [nintendo, nintendo2, nintendo3, nintendo4, nintendo5, nintendo6]

interface IIAEvaluationProps {
  /* true = el switch de batería se muestra, false = no se muestra, null = aún no se sabe */
  showSwitchBattery?: boolean | null
  /* true = el modelo está en el catálogo de batería pero el seller lo evalúa con Discounts
     (Macstore México), así que el paso de batería existe aunque no se muestre el switch */
  useDiscountsByBatteryModel?: boolean
}

const IAEvaluation: React.FC<IIAEvaluationProps> = ({ showSwitchBattery = null, useDiscountsByBatteryModel = false }) => {
  const { ctx, saveCtx } = useTradeinContext()
  const [images, setImages] = useState<(File | null)[]>(Array(6).fill(null))
  const { id: idParam, slug } = useParams()
  // Fuera de la ruta del detalle (modal del listado) el id no viene en la url, se toma del contexto.
  const id = idParam ?? String(ctx.tradein.id)
  const [data, setData] = useState<{ loading: boolean, result: any, cat: string, discount: number}>({ loading: false, result: null, cat: '', discount: 0 })
  const [defaultImagesState, setDefaultImagesState] = useState<string[]>(defaultImagesSmartPhone)
  const [imageTextState, setImageTextState] = useState<string[]>(['Imagen frontal', 'Imagen trasera', 'Imagen lateral derecha', 'Imagen inferior', 'Imagen superior', 'Imagen lateral izquierda'])
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const isMacstoreMexico = configSeller.config.s3.FOLDER_APP === 'ti_macstore'
  const isOppoMexico = configSeller.config.s3.FOLDER_APP === 'ti_oppo'
  const isElektraMexico = configSeller.config.s3.FOLDER_APP === 'ti_elektra_mx'
  const isXiaomiMexico = configSeller.config.s3.FOLDER_APP === 'ti_xiaomi'
  const isSamsungMexico = configSeller.config.s3.FOLDER_APP === 'ti_samsung_mx'
  const isHuaweiMexico = configSeller.config.s3.FOLDER_APP === 'ti_huawei_mx'
  const isTelcelMexico = configSeller.config.s3.FOLDER_APP === 'ti_telcel_mx'
  const isTelcelCorpMexico = configSeller.config.s3.FOLDER_APP === 'ti_telcel_corp_mx'
  const isConectaPeru = configSeller.config.s3.FOLDER_APP === 'ti_conecta_peru'
  const isSamsungRom = configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe_rom'
  const isRipleyPeru = configSeller.config.s3.FOLDER_APP === 'ti_ripley_pe'
  const isMercadoLibreChile = configSeller.config.s3.FOLDER_APP === 'ti_mercado_libre_cl'
  const isCoppelMexico = configSeller.config.s3.FOLDER_APP === 'ti_coppel'
  const isSamsungMexicoFlipOrFold = isSamsungMexico && ctx.tradein.brand === 'Samsung' && (ctx.tradein.model.toLocaleLowerCase().includes('fold') || ctx.tradein.model.toLocaleLowerCase().includes('flip'))
  const isTelcelMexicoFlipOrFold = isTelcelMexico && ctx.tradein.brand === 'Samsung' && (ctx.tradein.model.toLocaleLowerCase().includes('fold') || ctx.tradein.model.toLocaleLowerCase().includes('flip'))
  const isTelcelCorpMexicoFlipOrFold = isTelcelCorpMexico && ctx.tradein.brand === 'Samsung' && (ctx.tradein.model.toLocaleLowerCase().includes('fold') || ctx.tradein.model.toLocaleLowerCase().includes('flip'))
  const { setRunTour, setSteps, lastFinishedTour } = useJoyRideContext()
  const [showScreenOffModal, setShowScreenOffModal] = useState(false)
  /* true = la batería se evalúa en Discounts (flujo de Apple, con % de salud) y no con el switch */
  const useDiscounts = canEvaluateBatteryWithSwitch(configSeller, ctx.tradein.id_sbu, ctx.tradein.brand) || useDiscountsByBatteryModel

  useEffect(() => {
    // Inicialización de textos e imágenes según tipo y permisos
    let newImageText: string[] = ['Imagen frontal', 'Imagen trasera', 'Imagen lateral derecha', 'Imagen inferior', 'Imagen superior', 'Imagen lateral izquierda']
    let newDefaultImages: string[] = defaultImagesSmartPhone
    if (isConsole(ctx.tradein.sbu)) {
      switch (ctx.tradein.brand) {
        case 'Nintendo':
          newImageText = ['Imagen general', 'Imagen trasera', 'Imagen con soporte (si incluye)', 'Imagen inferior', 'Imagen superior', 'Dock o Frontal (lite)']
          newDefaultImages = defaultImagesNintendo
          break
        case 'Sony':
          newImageText = ['Imagen general', 'Imagen inferior', 'Imagen lateral derecha', 'Imagen frontal', 'Imagen trasera', 'Imagen lateral izquierda']
          newDefaultImages = defaultConsoles
          break
        default:
          newImageText = ['Imagen general', 'Imagen inferior', 'Imagen lateral derecha', 'Imagen frontal', 'Imagen trasera', 'Imagen lateral izquierda']
          newDefaultImages = defaultConsoles
          break
      }
    }
    // SmartPhone con permisos especiales
    if (configSeller.config.permisos.ENABLE_IA_EVALUATION_2_PHOTOS === 1 && ctx.tradein.sbu === 'Smartphone' && (isSamsungMexicoFlipOrFold || isTelcelMexicoFlipOrFold || isTelcelCorpMexicoFlipOrFold)) {
      newImageText = ['Imagen frontal', 'Imagen trasera', 'Imagen pantalla secundaria']
      newDefaultImages = [ImgPhone1, ImgPhone2, ImgPhone1]
      setImages(Array(3).fill(null))
    } else if (configSeller.config.permisos.ENABLE_IA_EVALUATION_2_PHOTOS === 1 && ctx.tradein.sbu === 'Smartphone') {
      newImageText = ['Imagen frontal', 'Imagen trasera']
      newDefaultImages = [ImgPhone1, ImgPhone2]
      setImages(Array(2).fill(null))
    }
    setImageTextState(newImageText)
    setDefaultImagesState(newDefaultImages)
  }, [ctx.tradein.sbu, ctx.tradein.brand, configSeller.config.permisos, isSamsungMexicoFlipOrFold, isTelcelMexicoFlipOrFold, isTelcelCorpMexicoFlipOrFold])

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const file = event.target.files?.[0]
    if (!file) return

    const compressed = await imageCompression(file, {
      maxSizeMB: 0.8,
      maxWidthOrHeight: 800,
      useWebWorker: true
    })

    setImages((prevImages) => {
      const newImages = [...prevImages]
      newImages[index] = compressed
      console.log('🚀 ~ setImages ~ newImages:', newImages)
      return newImages
    })
  }

  const handleRemoveImage = (index: number) => {
    setImages((prevImages) => {
      const newImages = [...prevImages]
      newImages[index] = null
      return newImages
    })
  }

  /* el grade quality se recalcula desde el grado IA solo en smartphones que no tienen ningún paso
     de batería por delante, porque ahí nadie más va a escribir ese dato.
     Ojo que showSwitchBattery === false junta dos casos y solo uno califica:
     - useDiscounts (Apple): no lleva switch porque va por Discounts, y ese guardado escribe el % de
       salud real. Asumir «sobre 80%» acá saltaría el paso y dejaría el sufijo equivocado.
     - modelo fuera del catálogo: no lleva switch ni Discounts, este es el caso que se asume. */
  const canUpdateGradeQuality = ctx.tradein.sbu === 'Smartphone' && !useDiscounts && showSwitchBattery === false

  const updateGradeQuality = async () => {
    try {
      await webApiService.updateGradeQuality({ idTradein: Number(id), batterySuffix: '1' })
    } catch (error: any) {
      const msg = error.response?.data.message ?? error.message ?? 'Error al actualizar el grado de calidad'
      enqueueSnackbar(msg, { variant: 'error' })
      console.log('error updateGradeQuality ==>', msg)
    }
    try {
      await webApiService.updateOnlyBatteryHealth({ idTradein: Number(id), isBatteryHealthy: 1 })
    } catch (error: any) {
      const msg = error.response?.data.message ?? error.message ?? 'Error al actualizar el grado de calidad'
      enqueueSnackbar(msg, { variant: 'error' })
      console.log('error updateGradeQuality ==>', msg)
    }
  }

  async function consultaAI () {
    setData({ ...data, loading: true })
    const base64Images = await imagesToBase64Array(images)
    const payload = {
      metadata: { id_tradein: id, seller: slug, sbu: isConsole(ctx.tradein.sbu) ? 12 : 1 },
      images: base64Images
    }
    console.log('👀 payload:', payload)
    webApiService.saveIAResult(payload)
      .then(async (response) => {
        console.log('🚀 ~ .then ~ response:', response)
        setData({ ...data, loading: false, result: response.data, cat: response.data.categoria })
        if (canUpdateGradeQuality && response.data.categoria !== undefined && response.data.categoria !== null) {
          await updateGradeQuality()
        }
        saveCtx({ ...ctx, reload: true, tradein: { ...ctx.tradein, grade: response.data.categoria } })
      }).catch((error) => {
        if (error.status === 500) {
          enqueueSnackbar(error.response.data.message, { variant: 'error' })
        } else {
          enqueueSnackbar(error.message, { variant: 'error' })
        }
        setData({ ...data, loading: false })
        saveCtx({ ...ctx, reload: true })
        console.log('error ==>', error)
      })
  }

  const loadData = () => {
    setData({ ...data, loading: true })
    webApiService.getIAEvaluation(Number(id)).then(res => {
      setData({ ...data, loading: false, result: res.data.result, cat: res.data.result.categoria })
    })
      .catch((error) => {
        setData({ ...data, loading: false })
        console.log('Error loading data :', error)
      })
  }

  useEffect(() => {
    if (ctx.tradein.grade_IA !== null) {
      loadData()
    } else {
      if (ctx.tradein.id_status === 4) {
        setSteps([{
          target: '.ia-evaluation',
          content: 'Aquí puedes cargar las imágenes del dispositivo para que sean evaluadas por nuestro sistema de inteligencia artificial y obtener una evaluación estética automática.',
          placement: 'top',
          disableBeacon: true
        }])
        setTimeout(() => {
          setRunTour(true)
        }, 2000)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, ctx.tradein.grade_IA, ctx.tradein.id_status])

  useEffect(() => {
    if (ctx.tradein.grade_IA !== null) {
      loadData()
    } else {
      if (ctx.tradein.id_status === 4) {
        setSteps([{
          target: '.ia-evaluation',
          content: 'Aquí puedes cargar las imágenes del dispositivo para que sean evaluadas por nuestro sistema de inteligencia artificial y obtener una evaluación estética automática.',
          placement: 'top',
          disableBeacon: true
        }])
        setRunTour(true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, ctx.tradein.grade_IA, ctx.tradein.id_status])

  console.log('ctx.tradein.id_status ==> ', ctx.tradein.id_status)

  useEffect(() => {
    if (images.filter(img => img === null).length === 0) {
      setSteps([{
        target: '.ia-evaluation-analizar',
        content: 'Presiona este botón para analizar las imágenes cargadas y obtener la evaluación estética del dispositivo.',
        placement: 'top',
        disableBeacon: true
      }])
      setRunTour(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [images])

  /* al saltar o finalizar el joyride del paso de evaluación IA (no el del botón analizar, ni
     ningún otro), se recuerda al usuario que la foto frontal debe ir con la pantalla apagada
     para que la IA la evalúe bien */
  useEffect(() => {
    if (lastFinishedTour === null) return
    const isIAEvaluationStep = lastFinishedTour.targets.some((target: string) => target === '.ia-evaluation')
    if (isIAEvaluationStep) {
      setShowScreenOffModal(true)
    }
  }, [lastFinishedTour])

  /* Con un recálculo pendiente el equipo cotizado todavía no es el que se está evaluando, así que
     no corresponde analizar las fotos: se pide recalcular primero, igual que en el paso de batería
     (ver Discounts). Es la misma condición con la que el detalle decide mostrar la evaluación IA. */
  const needsRecalculate = hasPendingRecalculate(ctx.tradein)
  // Con IMEI inválido no se analiza hasta que lo ingresen a mano (si ya hay resultado no bloquea).
  const needsImei = hasInvalidImei(ctx.tradein) && ctx.tradein.grade_IA === null

  /* "Analizar" solo aparece cuando aún no hay resultado (ni cat local ni grade_IA persistido), ya
     se cargaron todas las imágenes requeridas, no hay recálculo pendiente, y el paso no está
     oculto por id_status === 1. */
  const canShowAnalizar = ctx.tradein.id_status !== 1 && !needsRecalculate && !needsImei && data.cat === '' && ctx.tradein.grade_IA === null && images.filter((img) => img === null).length === 0

  const inlineAction = useStepFooterAction(
    canShowAnalizar
      ? (
        <Button className='ia-evaluation-analizar' variant='secondary' disabled={data.loading} onClick={consultaAI}>
          {data.loading ? 'Analizando...' : 'Analizar'}
        </Button>
        )
      : null,
    [canShowAnalizar, data.loading, needsRecalculate, needsImei]
  )

  if (ctx.tradein.id_status === 1) {
    return <div />
  }

  if (needsRecalculate) {
    return (
      <StepCard
        icon={<MdImageSearch />}
        title='Evaluación estética'
        subtitle='Análisis automático por IA'
        className='ia-evaluation h-full'
      >
        <NUIAlert type='info'>Se requiere recalcular el dispositivo.</NUIAlert>
      </StepCard>
    )
  }

  if (needsImei) {
    return (
      <StepCard
        icon={<MdImageSearch />}
        title='Evaluación estética'
        subtitle='Análisis automático por IA'
        className='ia-evaluation h-full'
      >
        <NUIAlert type='warning'>Por favor ingresa el IMEI manualmente, el IMEI detectado no es válido.</NUIAlert>
      </StepCard>
    )
  }

  return (
    <StepCard
      icon={<MdImageSearch />}
      title='Evaluación estética'
      subtitle='Análisis automático por IA'
      className='ia-evaluation h-full'
      right={data.result !== null && !(data.result.newDiscountAmount === undefined || isMacstoreMexico || isSamsungRom || isConectaPeru || isSamsungMexico || isRipleyPeru || isTelcelMexico || isTelcelCorpMexico || isXiaomiMexico || isOppoMexico || isElektraMexico || isMercadoLibreChile || isCoppelMexico)
        ? <div className='text-end font-black text-lg whitespace-nowrap'>Monto a descontar: <span className='text-primary'>{currencyFormat(Number(data.result.newDiscountAmount), import.meta.env.VITE_COUNTRY)}</span></div>
        : undefined}
    >
      <div className={(data.cat !== '' || ctx.tradein.grade_IA !== null) ? 'hidden' : 'flex p-2 gap-4'}>
        <p className='mb-3 flex-1'>Para iniciar la evaluación estética es necesario cargar todas las imágenes que se solicitan a continuación:</p>
      </div>
      <div className='py-2 text-2xl font-bold' hidden={!data.loading || data.cat !== ''}><GradientText>Analizando los datos</GradientText></div>
      <div className='py-2' hidden={data.result === null}>
        <NUIAlert type={data.cat === 'A' ? 'success' : data.cat === 'B' || data.cat === 'C' ? 'warning' : data.cat === 'D' ? 'error' : 'error'}>
          {data.result !== null &&
            imageTextState.slice(0, (isMacstoreMexico || isHuaweiMexico || !isSamsungMexicoFlipOrFold || !isTelcelMexicoFlipOrFold || !isTelcelCorpMexicoFlipOrFold) ? 2 : imageTextState.length).map((label, idx) => {
              const comentario = data.result[`comentario_img_${idx + 1}`]
              return comentario ? <p key={idx}>{label}: {comentario}</p> : null
            })}
          {/* {data.result !== null ? <p>Imagen frontal: {data.result.comentario_img_1}</p> : null}
          {data.result !== null ? <p>Imagen trasera: {data.result.comentario_img_2}</p> : null}
          {data.result !== null ? <p>Imagen lateral derecha: {data.result.comentario_img_3}</p> : null}
          {data.result !== null ? <p>Imagen inferior: {data.result.comentario_img_4}</p> : null}
          {data.result !== null ? <p>Imagen superior: {data.result.comentario_img_5}</p> : null}
          {data.result !== null ? <p>Imagen lateral izquierda: {data.result.comentario_img_6}</p> : null} */}
        </NUIAlert>
      </div>
      <div className={data.loading || data.cat !== '' || ctx.tradein.grade_IA !== null ? 'hidden' : 'flex flex-wrap gap-6 py-2'}>
        {(() => {
          let labelsToShow
          if (isSamsungMexicoFlipOrFold || isTelcelMexicoFlipOrFold || isTelcelCorpMexicoFlipOrFold) {
            labelsToShow = imageTextState.slice(0, 3)
          } else if (configSeller.config.permisos.ENABLE_IA_EVALUATION_2_PHOTOS === 1 && ctx.tradein.sbu === 'Smartphone') {
            labelsToShow = imageTextState.slice(0, 2)
          } else {
            labelsToShow = imageTextState
          }
          return labelsToShow.map((label, index) => (
            <div
              key={index} className={images[index] === null ? 'w-36 flex flex-col items-center gap-3 aspect-[10/16] relative rounded-lg border-2 border-dashed border-blue-400 bg-cover bg-center p-3 before:bg-opacity-50 before:bg-white before:absolute before:inset-0 before:rounded-lg' : 'w-36 flex flex-col items-center gap-3 aspect-[10/16] relative rounded-lg border-2 border-dashed border-blue-400 bg-cover bg-center p-3'}
              style={{ backgroundImage: `url(${images[index] ? URL.createObjectURL(images[index]!) : defaultImagesState[index]})` }}
            >
              {images[index] && (
                <Button
                  size='icon-xs'
                  className='absolute top-2 right-2 rounded-full bg-red-500 text-white hover:bg-red-700'
                  onClick={() => handleRemoveImage(index)}
                >
                  <MdClose />
                </Button>
              )}
              <input
                type='file'
                accept='image/*'
                id={`file-input-${index}`}
                style={{ display: 'none' }}
                onChange={(e) => handleFileChange(e, index)}
              />

              <Button
                size='sm'
                className='relative mt-auto h-auto text-center whitespace-normal py-1.5 leading-tight'
                onClick={() => {
                  const input = document.getElementById(`file-input-${index}`)
                  input?.click()
                }}
              >
                {`Cargar ${label}`}
              </Button>
            </div>
          ))
        })()}
      </div>
      {/* se puede volver a analizar hasta que se genere el contrato, y antes de eso hasta que se
          cierre el paso de batería que corresponda al flujo del equipo (ver canReanalyzeIA) */}
      <div className='text-end' hidden={data.result === null || !canReanalyzeIA(ctx.tradein, showSwitchBattery, useDiscounts)}>
        <Button disabled={data.loading} onClick={() => { setData({ ...data, result: null, cat: '' }); saveCtx({ ...ctx, tradein: { ...ctx.tradein, grade_IA: null } }) }}>{data.loading ? 'Analizando...' : 'Volver a Analizar'}</Button>
      </div>
      {/* Sin footer compartido (página de detalle clásica) el botón del paso se dibuja acá. */}
      {inlineAction && <div className='flex justify-end pt-4'>{inlineAction}</div>}
      <Modal isOpen={showScreenOffModal} onClose={() => setShowScreenOffModal(false)} placement='center' size='sm'>
        <ModalContent>
          {(closeModal) => (
            <>
              <ModalHeader className='flex items-center gap-2'>
                <MdOutlineWarningAmber className='text-xl text-amber-500' />
                Atención
              </ModalHeader>
              <ModalBody>
                <p>Por favor ingresa la fotografía de frente del teléfono con la pantalla apagada.</p>
              </ModalBody>
              <ModalFooter>
                <Button onClick={closeModal}>Entendido</Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </StepCard>
  )
}

export default IAEvaluation
